/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `Úroveň dovedností`
};

const da_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `Spillets niveau`
};

const de_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `Spielniveau`
};

const en_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `Skill Level`
};

const es_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `nivel de juego`
};

const fr_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `Niveau de jeu`
};

const hu_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `A Játék Szintje`
};

const it_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `livello di gioco`
};

const nl_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `spelniveau`
};

const pl_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `poziom gry`
};

const pt_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `nível de jogo`
};

const sv_attributes_skill_level = /** @type {(inputs: {}) => string} */ () => {
	return `nivå av spel`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_skill_level = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_skill_level(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_skill_level", locale)
	if (locale === "cs") return cs_attributes_skill_level(inputs)
	if (locale === "da") return da_attributes_skill_level(inputs)
	if (locale === "de") return de_attributes_skill_level(inputs)
	if (locale === "en") return en_attributes_skill_level(inputs)
	if (locale === "es") return es_attributes_skill_level(inputs)
	if (locale === "fr") return fr_attributes_skill_level(inputs)
	if (locale === "hu") return hu_attributes_skill_level(inputs)
	if (locale === "it") return it_attributes_skill_level(inputs)
	if (locale === "nl") return nl_attributes_skill_level(inputs)
	if (locale === "pl") return pl_attributes_skill_level(inputs)
	if (locale === "pt") return pt_attributes_skill_level(inputs)
	return sv_attributes_skill_level(inputs)
};
export { attributes_skill_level as "attributes.skill_level" }